/**
 * EAkte Plus API
 * API eakteplus document metadata api
 *
 * OpenAPI spec version: 1.0.0
 * Contact: ehgidencores@eulerhermes.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
	HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';
import { DocumentFileMetadata } from '../model/documentFileMetadata';
import { DocumentUrl } from '../model/documentUrl';
import { JadeUploadNotification } from '../model/jadeUploadNotification';
import { ValidatedMetadataResponse } from '../model/validatedMetadataResponse';
import { DocumentUploadResponse } from '../model/documentUploadResponse';
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { environment } from '../../environments/environment';

@Injectable()
export class DocumentService {

	protected basePath = environment.demoApi;
	public defaultHeaders = new HttpHeaders();
	public configuration = new Configuration();

	constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
		if (basePath) {
			this.basePath = basePath;
		}
		if (configuration) {
			this.configuration = configuration;
			this.basePath = basePath || configuration.basePath || this.basePath;
		}
	}

	/**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
	private canConsumeForm(consumes: string[]): boolean {
		const form = 'multipart/form-data';
		for (const consume of consumes) {
			if (form === consume) {
				return true;
			}
		}
		return false;
	}


	/**
     * Return the DocumentMetadata with file object
     * Download file content identified by dui
     * @param dui Document Unique Identifier
     * @param authorization Security token authenticating a user
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
	public documentGet(dui?: string, observe?: 'body', reportProgress?: boolean): Observable<DocumentUrl>;
	public documentGet(dui?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DocumentUrl>>;
	public documentGet(dui?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DocumentUrl>>;
	public documentGet(dui?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

		let headers = this.defaultHeaders;

		if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
			headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
		}

		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
			'application/json'
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [
			'application/json'
		];
		const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected != undefined) {
			headers = headers.set('Content-Type', httpContentTypeSelected);
		}
		return this.httpClient.request<Blob>('get',`${this.basePath}/documents/${encodeURIComponent(String(dui))}`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

	/**
     * Upload a file for document and set metadata on document
     * Creates document metadata and uploads file content
     * @param authorization Security token authenticating a user
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
	public documentPost(body?: string, observe?: 'body', reportProgress?: boolean): Observable<DocumentUploadResponse>;
	public documentPost(body?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DocumentUploadResponse>>;
	public documentPost(body?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DocumentUploadResponse>>;
	public documentPost(body?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

		let headers = this.defaultHeaders;

		// authentication (oauth) required
		if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
			headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
		}

		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
			'application/json'
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		headers = headers.set('Content-Type', 'application/json');

		// to determine the Content-Type header
		const consumes: string[] = [
			'application/json'
		];
		return this.httpClient.request<DocumentUploadResponse>('post',`${this.basePath}/documents`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				body: body,
				reportProgress: reportProgress
			}
		);
	}

	public validateMetadata(body?: string, observe?: 'body', reportProgress?: boolean): Observable<ValidatedMetadataResponse>;
	public validateMetadata(body?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ValidatedMetadataResponse>>;
	public validateMetadata(body?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ValidatedMetadataResponse>>;
	public validateMetadata(body?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

		let headers = this.defaultHeaders;

		// authentication (oauth) required
		if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
			headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
		}

		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
			'application/json'
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		headers = headers.set('Content-Type', 'application/json');

		// to determine the Content-Type header
		const consumes: string[] = [
			'application/json'
		];
		return this.httpClient.request<string>('post',`${this.basePath}/document/metadata/validate`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				body: body,
				reportProgress: reportProgress
			}
		);
	}

	public jadeUploadNotification(body?: JadeUploadNotification, observe?: 'body', reportProgress?: boolean): Observable<any>;
	public jadeUploadNotification(body?: JadeUploadNotification, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	public jadeUploadNotification(body?: JadeUploadNotification, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	public jadeUploadNotification(body?: JadeUploadNotification, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

		if (body === null || body === undefined) {
			throw new Error('Required parameter url was null or undefined when calling jadeUploadNotification.');
		}
		let headers = this.defaultHeaders;

		if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
			headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
		}

		let httpHeaderAccepts: string[] = [
			'application/json'
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		headers = headers.set('Content-Type', 'application/json');

		const consumes: string[] = [
			'application/json'
		];

		return this.httpClient.request<JadeUploadNotification>('put', `${this.basePath}/documents/${body.dui}/metadata`,
			{
				body: body,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

}
